import { parseTime } from './index'

/**
 * 时间格式化过滤器
 * @param {string|number|Date} time - 时间
 * @param {string} format - 格式化字符串
 * @returns {string} 格式化后的时间字符串
 */
export function timeFilter(time, format) {
  return parseTime(time, format)
}

/**
 * 日期过滤器 - 只显示日期
 * @param {string|number|Date} time - 时间
 * @returns {string} 格式化后的日期字符串
 */
export function dateFilter(time) {
  return parseTime(time, '{y}-{m}-{d}')
}

/**
 * 时间过滤器 - 只显示时间
 * @param {string|number|Date} time - 时间
 * @returns {string} 格式化后的时间字符串
 */
export function timeOnlyFilter(time) {
  return parseTime(time, '{h}:{i}:{s}')
}

/**
 * 日期时间过滤器 - 显示日期和时间
 * @param {string|number|Date} time - 时间
 * @returns {string} 格式化后的日期时间字符串
 */
export function datetimeFilter(time) {
  return parseTime(time, '{y}-{m}-{d} {h}:{i}:{s}')
}

/**
 * 中文日期过滤器
 * @param {string|number|Date} time - 时间
 * @returns {string} 中文格式的日期字符串
 */
export function chineseDateFilter(time) {
  return parseTime(time, '{y}年{m}月{d}日')
}

/**
 * 中文日期时间过滤器
 * @param {string|number|Date} time - 时间
 * @returns {string} 中文格式的日期时间字符串
 */
export function chineseDatetimeFilter(time) {
  return parseTime(time, '{y}年{m}月{d}日 {h}:{i}:{s}')
}

/**
 * 相对时间过滤器
 * @param {string|number|Date} time - 时间
 * @returns {string} 相对时间字符串
 */
export function relativeTimeFilter(time) {
  if (!time) return '-'
  
  const now = new Date()
  const target = new Date(time)
  const diff = now - target
  
  const minute = 60 * 1000
  const hour = 60 * minute
  const day = 24 * hour
  const month = 30 * day
  const year = 365 * day
  
  if (diff < minute) {
    return '刚刚'
  } else if (diff < hour) {
    return Math.floor(diff / minute) + '分钟前'
  } else if (diff < day) {
    return Math.floor(diff / hour) + '小时前'
  } else if (diff < month) {
    return Math.floor(diff / day) + '天前'
  } else if (diff < year) {
    return Math.floor(diff / month) + '个月前'
  } else {
    return Math.floor(diff / year) + '年前'
  }
}

/**
 * 星期过滤器
 * @param {string|number|Date} time - 时间
 * @returns {string} 星期字符串
 */
export function weekFilter(time) {
  return parseTime(time, '星期{a}')
}

/**
 * 月份过滤器
 * @param {string|number|Date} time - 时间
 * @returns {string} 月份字符串
 */
export function monthFilter(time) {
  return parseTime(time, '{y}年{m}月')
}

/**
 * 季度过滤器
 * @param {string|number|Date} time - 时间
 * @returns {string} 季度字符串
 */
export function quarterFilter(time) {
  if (!time) return '-'
  
  const date = new Date(time)
  const month = date.getMonth() + 1
  const year = date.getFullYear()
  
  let quarter = ''
  if (month <= 3) {
    quarter = 'Q1'
  } else if (month <= 6) {
    quarter = 'Q2'
  } else if (month <= 9) {
    quarter = 'Q3'
  } else {
    quarter = 'Q4'
  }
  
  return `${year}年${quarter}`
}

/**
 * 年龄过滤器
 * @param {string|number|Date} birthDate - 出生日期
 * @returns {string} 年龄字符串
 */
export function ageFilter(birthDate) {
  if (!birthDate) return '-'
  
  const today = new Date()
  const birth = new Date(birthDate)
  let age = today.getFullYear() - birth.getFullYear()
  const monthDiff = today.getMonth() - birth.getMonth()
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--
  }
  
  return age + '岁'
}

/**
 * 持续时间过滤器
 * @param {number} seconds - 秒数
 * @returns {string} 持续时间字符串
 */
export function durationFilter(seconds) {
  if (!seconds || seconds < 0) return '-'
  
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60
  
  if (hours > 0) {
    return `${hours}小时${minutes}分钟${secs}秒`
  } else if (minutes > 0) {
    return `${minutes}分钟${secs}秒`
  } else {
    return `${secs}秒`
  }
} 


// WEBPACK FOOTER //
// ./src/utils/filters.js